import React, { Component } from 'react'
import Button from './Button.jsx'

class ErrorBoundary extends Component {
  constructor(props) {
    super(props)
    this.state = { hasError: false }
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error }
  }

  componentDidCatch(error, errorInfo) {
    console.error('ErrorBoundary caught an error:', error, errorInfo)
  }

  render() {
    if (this.state.hasError) {
      if (this.props.fallback) {
        return this.props.fallback
      }

      return (
        <div className='min-h-dvh flex items-center justify-center bg-gray-50'>
          <div className='text-center p-8 max-w-md'>
            <div className='mb-6'>
              <h1 className='text-2xl font-semibold text-gray-900 mb-2'>Something went wrong</h1>
              <p className='text-gray-600'>We encountered an unexpected error. Please try refreshing the page.</p>
            </div>

            <div className='space-y-3'>
              <Button variant='primary' onClick={() => window.location.reload()} className='w-full' size='large'>
                Refresh Page
              </Button>

              <Button
                variant='cancel'
                onClick={() => {
                  this.setState({ hasError: false, error: undefined })
                }}
                className='w-full'
                size='large'
              >
                Try Again
              </Button>
            </div>

            {process.env.NODE_ENV === 'development' && this.state.error && (
              <details className='mt-6 text-left'>
                <summary className='cursor-pointer text-gray-500 hover:text-gray-700'>Error Details</summary>
                <pre className='mt-2 text-xs text-red-600 bg-red-50 p-3 rounded overflow-auto'>
                  {this.state.error.stack}
                </pre>
              </details>
            )}
          </div>
        </div>
      )
    }

    return this.props.children
  }
}

// Named export for compatibility
export { ErrorBoundary }
